import { render, staticRenderFns } from "./vip-detail.vue?vue&type=template&id=ae6f7cc4&scoped=true&"
import script from "./vip-detail.vue?vue&type=script&lang=js&"
export * from "./vip-detail.vue?vue&type=script&lang=js&"
import style0 from "./vip-detail.vue?vue&type=style&index=0&id=ae6f7cc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae6f7cc4",
  null
  
)

export default component.exports